<dt class="accordion-header" (click)="toggle()" [class.open]="open" [innerHTML]="title"></dt>
<dd class="accordion-main" [innerHTML]="contents" [@slideUpDown]="open" [style]="{ height: 0, paddingBottom: 0 }"></dd>
